var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scheduleHtml)?_c('div',{staticClass:"program-schedule",domProps:{"innerHTML":_vm._s(_vm.scheduleHtml)}}):_c('div',{staticClass:"program-schedule text-sm py-4 min-h-screen"},[_vm._v("Loading...")])}
var staticRenderFns = []

export { render, staticRenderFns }